import React from 'react';

import { latexParser, generateKeyVal } from '../../../utilities/utilities';

import classes from './Participant.module.scss';

const Participant = props => {
    const showAbstractHandler = () => {
        props.showModal(true);
        props.setModalContent({
            title: latexParser(props.title),
            body: [<h3 key={generateKeyVal('key')}>{props.name}, {props.affiliation}</h3>, 
            <div key={generateKeyVal('key')} className={classes.Body}>{props.abstract ? latexParser(props.abstract) : null}</div>]
        })
    }
    return <li className={classes.Participant}>
        <div>{props.name}, {props.affiliation}</div>
        {/* <div className={classes.Title}>{latexParser(props.title)}</div> */}
        {/* {props.auth && <div className={classes.ShowControls} >
            <span onClick={showAbstractHandler} className={classes.Control}>Show abstract</span>
            <span className={classes.Control}>Show talk info</span>
            </div>} */}
    </li>
}

export default Participant;